import { keyframes } from '@mui/material/styles';

export type ShimmerOptions = {
  active: boolean;
  contentOpacity?: number;
  speedMs?: number;
  lightOpacity?: number;
};

const shimmerSlide = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
`;

export const createLoadingShimmerStyles = (options: ShimmerOptions): Record<string, unknown> => {
  const { active, contentOpacity = 0.6, speedMs = 1200, lightOpacity = 0.6 } = options;

  return {
    position: 'relative',
    overflow: 'hidden',
    ...(active
      ? {
          '> *': {
            opacity: contentOpacity,
          },
          '::after': {
            content: '""',
            position: 'absolute',
            inset: 0,
            background: `linear-gradient(110deg, rgba(255,255,255,0) 0%, rgba(255,255,255,${lightOpacity}) 30%, rgba(255,255,255,${lightOpacity}) 50%, rgba(255,255,255,0) 80%)`,
            transform: 'translateX(-100%)',
            animation: `${shimmerSlide} ${speedMs}ms ease-in-out infinite`,
          },
        }
      : {}),
  };
};

export default createLoadingShimmerStyles;
